// Dependencies
import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter, RouteComponentProps, Link} from "react-router-dom";
import _ from "lodash";

// Components
import {Components} from "@webtech/webtech-ui-react/build/webtech-ui";
import {SubsidiaryUtils} from "../../../../utils/Subsidiary/SubsidiaryUtils";

// Store
import {ActionCreator} from "../../../../actions/actions";
import {subsidiariesStoreSelectors} from "../../store/store";
import {SubsidiariesActionCreators} from "../../actions/actionCreators";
import {Subsidiary} from "../../../halls/types/subsidiaries";

// Utils
import {checkForRouteAvailability} from "../../../../utils/Authorization/authorization";

// Styles
import "./SubsidiariesList.component.scss";
import Drawer from "../../../../utils/Drawer/Drawer.component";

export interface SubsidiariesListProps extends RouteComponentProps {
    getSubsidiaries: ActionCreator;
    saveSubsidiary: ActionCreator;
    subsidiariesLoading: boolean;
    subsidiariesList: Subsidiary[];
    subsidiaryEditing: boolean;
    startSubsidiaryEditing: ActionCreator;
    endSubsidiaryEditing: ActionCreator;
}

export interface SubsidiariesListState {
    editingSubsidiary: Subsidiary;
}

class SubsidiariesList extends Component<
    SubsidiariesListProps,
    SubsidiariesListState
> {
    canEdit: boolean;
    uploadedFiles: number;

    constructor(props) {
        super(props);

        this.state = {
            editingSubsidiary: undefined
        };

        this.props.getSubsidiaries();

        this.canEdit = checkForRouteAvailability("subsidiary:edit");
        this.uploadedFiles = 0;
    }

    closeEditSubsidiary = () => {
        this.props.endSubsidiaryEditing();
        this.setState({
            editingSubsidiary: undefined
        });
    };

    editSubsidiary = subsidiary => {
        this.setState({
            editingSubsidiary: {...subsidiary}
        });
        this.props.startSubsidiaryEditing();
    };

    handleFile = e => {
        if (e.length > 0) {
            this.getBase64(e[0]).then((data: string) => {
                const newEditing = {
                    ...this.state.editingSubsidiary,
                    logo_file: e[0],
                    logo: data
                };

                this.setState({
                    editingSubsidiary: newEditing
                });
            });
        } else {
            let newEditing = {
                ...this.state.editingSubsidiary
            };

            if (newEditing.hasOwnProperty("logo_file")) {
                delete newEditing.logo_file;
            }

            const previous = _.find(this.props.subsidiariesList, {
                id: newEditing.id
            });
            if (previous) {
                newEditing.logo = previous.logo;
            }

            this.uploadedFiles++;
            this.setState({
                editingSubsidiary: newEditing
            });
        }
    };

    getBase64 = file => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    };

    getFileIfAvailable() {
        if (
            this.state.editingSubsidiary &&
            this.state.editingSubsidiary.logo_file
        ) {
            return [this.state.editingSubsidiary.logo_file];
        }
        return [];
    }

    saveSubsidiaryLogo = () => {
        this.props.saveSubsidiary(this.state.editingSubsidiary);
    };

    render() {
        return (
            <div id="SubsidiariesList" className="content">
                <div className="container">
                    <div className="row">
                        <div className="col-6">
                            <h2>Subsidiary Logos</h2>
                        </div>
                    </div>
                    <div className="subsidiaries-list">
                        {this.props.subsidiariesLoading ? (
                            <div className="subsidiaries-list-loading">
                                <Components.LoadingRipple
                                    width={"100px"}
                                    height={"100px"}
                                />
                            </div>
                        ) : (
                            <div className="subsidiaries row">
                                {this.props.subsidiariesList.map(
                                    (subsidiary, key) => {
                                        return (
                                            <div
                                                className="subsidiaries-card"
                                                key={key}
                                            >
                                                <span>
                                                    <p>Company: </p>
                                                    {subsidiary.company.name}
                                                </span>
                                                <span>
                                                    <p>Country: </p>
                                                    {SubsidiaryUtils.subsidiaryIcon(subsidiary)}
                                                    {subsidiary.country.name}
                                                </span>
                                                <span>
                                                    <p>Description: </p>
                                                    {subsidiary.description}
                                                </span>
                                                <span className="logo">
                                                    <p>
                                                        Reports Logo:
                                                        {this.canEdit && (
                                                            <button
                                                                className="tooltip-icon"
                                                                onClick={() =>
                                                                    this.editSubsidiary(
                                                                        subsidiary
                                                                    )
                                                                }
                                                            >
                                                                <span className="tooltip-text">Edit</span>
                                                                <i className="icon-pencil-alt-light"></i>
                                                            </button>
                                                        )}
                                                    </p>
                                                    {subsidiary.logo ? (
                                                        <img
                                                            src={
                                                                subsidiary.logo
                                                            }
                                                        />
                                                    ) : (
                                                        <img
                                                            className="error"
                                                            src="/game-logo.png"
                                                        />
                                                    )}
                                                </span>
                                            </div>
                                        );
                                    }
                                )}
                            </div>
                        )}
                    </div>
                </div>
                {this.state.editingSubsidiary !== undefined &&
                    this.canEdit &&
                    this.props.subsidiaryEditing && (
                        <Drawer
                            title="Edit Reports Logo"
                            onClose={this.closeEditSubsidiary}
                        >
                            <div
                                key={this.state.editingSubsidiary.id}
                                className="logo-upload"
                            >
                                <div id="upload" className="row">
                                    {this.state.editingSubsidiary.logo && (
                                        <div className="col-12 logo-preview">
                                            <img
                                                src={
                                                    this.state.editingSubsidiary
                                                        .logo
                                                }
                                            />
                                        </div>
                                    )}
                                    <div className="col-12">
                                        <Components.FileBox
                                            key={this.uploadedFiles}
                                            displayMessage="Drag and drop logo"
                                            multipleFilesAllowed={false}
                                            displayIcon={""}
                                            onFilesChange={this.handleFile}
                                            files={this.getFileIfAvailable()}
                                        />
                                    </div>
                                    <div className="col-12">
                                        <button
                                            className="red-btn"
                                            disabled={
                                                !this.state.editingSubsidiary
                                                    .logo_file
                                            }
                                            onClick={this.saveSubsidiaryLogo}
                                        >
                                            <span>Save</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </Drawer>
                    )}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    subsidiariesList: subsidiariesStoreSelectors.subsidiariesList(state),
    subsidiariesLoading: subsidiariesStoreSelectors.subsidiariesLoading(state),
    subsidiaryEditing: subsidiariesStoreSelectors.subsidiaryEditing(state)
});

const mapDispatchToProps = {
    getSubsidiaries: SubsidiariesActionCreators.getSubsidiaries,
    saveSubsidiary: SubsidiariesActionCreators.saveSubsidiary,
    startSubsidiaryEditing: SubsidiariesActionCreators.startSubsidiaryEditing,
    endSubsidiaryEditing: SubsidiariesActionCreators.endSubsidiaryEditing
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(SubsidiariesList));
